import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Train, Laptop, Building2, MapPin } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-background relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-secondary/5 skew-x-12 pointer-events-none"></div>

      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row gap-16 items-center">

          {/* Image Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2 relative"
          >
            <div className="relative aspect-[4/5] md:aspect-square w-full max-w-md mx-auto">
              <div className="absolute inset-0 border-2 border-primary/30 translate-x-4 translate-y-4 rounded-sm"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent opacity-60 z-10"></div>
              <img
                src="/assets/images/profile_loco.webp"
                alt="xearox auf Rangierlok BR 294"
                className="w-full h-full object-cover rounded-sm border-2 border-border/50 shadow-2xl transition-all duration-700"
              />

              {/* Floating Stat Card */}
              <Card className="absolute -bottom-6 -right-6 z-20 w-48 bg-card border-primary/20 shadow-xl">
                <CardContent className="p-4 flex flex-col gap-2">
                  <div className="flex items-center gap-2 text-primary font-mono text-xs">
                    <MapPin className="w-3 h-3" />
                    <span>STANDORT</span>
                  </div>
                  <p className="font-display text-xl">OFFENBURG</p>
                  <p className="text-muted-foreground text-sm">DB Cargo AG</p>
                </CardContent>
              </Card>
            </div>
          </motion.div>

          {/* Text Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2"
          >
            <h2 className="text-4xl md:text-5xl font-display font-bold mb-6">
              ZWISCHEN <span className="text-primary">CODE</span> UND <span className="text-primary">SCHIENE</span>
            </h2>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed">
              <p>
                Hallo, ich bin <span className="text-foreground font-semibold">xearox</span>.
                Die meisten kennen mich vielleicht nur online, aber mein "echtes" Leben findet auf den Gleisen statt.
              </p>

              <div className="flex flex-col gap-4 pl-4 border-l-2 border-primary/20">
                <div className="flex items-start gap-4">
                  <div className="p-2 bg-secondary/20 rounded mt-1">
                    <Train className="w-5 h-5 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-foreground font-display text-xl mb-1">HAUPTBERUF</h3>
                    <p className="text-sm">Lokrangierführer & Streckenlokführer bei der <strong className="text-foreground">DB Cargo AG</strong>. Ich sorge dafür, dass Güter sicher und pünktlich an ihr Ziel kommen. Eine Arbeit mit Verantwortung, Stahl und Nachtschichten.</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="p-2 bg-secondary/20 rounded mt-1">
                    <Laptop className="w-5 h-5 text-accent" />
                  </div>
                  <div>
                    <h3 className="text-foreground font-display text-xl mb-1">LEIDENSCHAFT</h3>
                    <p className="text-sm">Indie Developer. Wenn ich nicht im Führerstand sitze, baue ich Software. Ich hauche alten Domains neues Leben ein und experimentiere mit Web-Technologien.</p>
                  </div>
                </div>
              </div>

              <p>
                Diese Webseite ist mein persönlicher Knotenpunkt. Hier verbinde ich meine technische Neugier mit meiner beruflichen Realität.
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;
